<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">
        {{ $t('setting.list.managementAsset.gps.historySubtitle') }}
        <strong>{{ imei }}</strong>
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Management GPS' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>
    <b-card class="mc-card__setting">
      <b-tabs content-class="text-muted" nav-wrapper-class="mc-tab">
        <ChangeTab status="ChangeTab" ref="changeTab" :item="imei" />
        <MoveTab status="MoveTab" ref="moveTab" :item="imei" />
      </b-tabs>
    </b-card>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import ChangeTab from './changeTab'
import MoveTab from './moveTab'

export default {
  page: {
    title: 'Change History',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    ChangeTab,
    MoveTab,
  },

  mixins: [Helper],

  data() {
    return {
      imei: this.$route.params.imei,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isWhitelabel: 'identity/isWhitelabel',
    }),
    title() {
      return this.$t('setting.list.managementAsset.gps.historyTitle')
    },
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.homePage.asset'),
          to: { name: 'Management Asset' },
        },
        {
          text: this.$t('setting.list.managementAsset.gps.title'),
          to: { name: 'Management GPS' },
        },
        {
          text: this.$t('setting.list.managementAsset.gps.historyTitle'),
          active: true,
        },
      ]
    },
  },
}
</script>
